import Editor from "./views/Editor";
import ModalWrapper from "./views/ModalWrapper";
import ModalWrap from "../HBModal/ModalWrap";

export const PinEditorModal = ModalWrap(ModalWrapper);
export default Editor;
